import styled from 'styled-components';
import { colors } from 'styles/colors';

export const BadgeContainer = styled.div`
  height: 32px;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid ${colors.stroke['sub-300']};
  border-radius: 140px;
  background-color: ${colors.bg['soft-200']};
  padding: 6px;
  padding-left: 8px;
  min-width: 174px;
  max-width: 212px;
  width: fit-content;

  span {
    font-size: 10px;
    font-weight: 600;
    color: ${colors.text['main-900']};
  }
`;
